import React, { useState, useRef } from 'react';
import { Direction, ImageSize, Language, ReduxState, TextDirection } from 'interface';
import { connect, ConnectedProps } from 'react-redux';
import SLPButton from 'utilities/slp/button/button.index';
import { SLPStartPageType } from './startPage.interface';
import './startPage.style.scss';
import SLPInput from 'utilities/slp/input/input.index';
import HintText from 'utilities/slp/hintText/hintText.index';
import useOnBlur from 'scripts/useOnBlur';

const SLPStartPage: React.FC<ConnectedProps<typeof connector> & SLPStartPageType> = function (
    props: ConnectedProps<typeof connector> & SLPStartPageType,
) {
    const lang = props.lang.SLP;
    const form = props.form;
    const [password, setPassword] = useState<string>();
    const logoRef = useRef<HTMLImageElement>(null);
    const count = useRef<number>(0);

    useOnBlur(logoRef, () => {
        count.current = 0;
    });
    function onClickHandler() {
        if (count.current < 10) count.current += 1;
        else {
            count.current = 0;
            if (props.onSecret) props.onSecret();
        }
    }
    return (
        <div
            className="ucheck-slp-start"
            style={{
                backgroundImage: `url(${
                    form.first_page_bg_file
                        ? form.first_page_bg_file?.file
                        : form.background_image_file
                        ? form.background_image_file.file
                        : form.background_color
                        ? ''
                        : undefined
                }`,
                backgroundColor: form.background_color,
            }}
        >
            <div>
                <div>
                    <img
                        ref={logoRef}
                        onClick={onClickHandler}
                        className={
                            form.logo_first_page_size === ImageSize.small
                                ? 'small'
                                : form.logo_first_page_size === ImageSize.medium
                                ? 'medium'
                                : ''
                        }
                        src={form.logo_first_page_file?.file}
                        alt={form.logo_first_page_file?.alt}
                    />
                    <h3>{form.first_page_title ? form.first_page_title : form.title}</h3>
                    <div className="hint-box">
                        <HintText value={props.form.first_page_description} />
                    </div>
                    {form.has_password ? (
                        <SLPInput
                            onChange={(e) => {
                                setPassword(e);
                            }}
                            // dir={form.direction}
                            type="password"
                            placeholder={form.password_title ? form.password_title : lang.password}
                        />
                    ) : null}
                    <SLPButton
                        disabled={(!password || password.length === 0) && form.has_password}
                        style={{ color: form.button_label_color }}
                        onClick={() => {
                            return props.next(password);
                        }}
                    >
                        {form.start_button && form.start_button.length > 0
                            ? form.start_button
                            : form.lang === Language.fa
                            ? lang.start
                            : lang.startEN}
                    </SLPButton>
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = (state: ReduxState) => ({
    direction: state.direction,
    isAuth: state.authStatus,
    lang: state.lang,
});

const connector = connect(mapStateToProps);
export default connector(SLPStartPage);
